import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const ConsiliulEparhial: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Consiliul Eparhial
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Președinte: Iustin - Eman Mihăilescu
          </Typography>
          <Typography variant="body1">
            Consiliul Eparhial este organul consultativ al eparhiei, 
            responsabil pentru luarea deciziilor importante.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ConsiliulEparhial;
